import { computed, ref } from 'vue'

type AppLanguage = 'is-IS' | 'en'

const STORAGE_KEY = 'birta.language'

function readStoredLanguage(): AppLanguage {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'is-IS'
  }
  catch {
    return 'is-IS'
  }
}

// Module-level singleton so the request service can import it directly.
export const appLanguage = ref<AppLanguage>(readStoredLanguage())

export function useAppLanguage() {
  const toggleLanguage = () => {
    appLanguage.value = appLanguage.value === 'is-IS' ? 'en' : 'is-IS'
    try {
      localStorage.setItem(STORAGE_KEY, appLanguage.value)
    }
    catch { /* storage not available */ }
  }

  // Label for the button shows the language the user can switch TO.
  const languageButtonLabel = computed(() =>
    appLanguage.value === 'is-IS' ? 'English' : 'Íslenska',
  )

  // Maps to PayloadCMS language key.
  const cmsLanguage = computed<'is' | 'en'>(() =>
    appLanguage.value === 'is-IS' ? 'is' : 'en',
  )

  return {
    appLanguage,
    toggleLanguage,
    languageButtonLabel,
    cmsLanguage,
  }
}
